import computed from './computed'
import data from './data'
import methods from './methods'
import mounted from './mounted'
import props from './props'
// import watch from './watch'

export default {
  computed,
  data,
  methods,
  mounted,
  props,
//  watch,
  // Motificado de locks para remove, onde ira excluir as opções selecionadas
  resourcePath: '/v1/professional/schedules/remove'
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/preview/resources/index.js